import moment from 'moment';
import { assign, cloneDeep, differenceBy, keys, values } from 'lodash';
import Axios from 'axios';
import { funnelsActions as actionConstants, funnelCodes, funnelUtilsConstants, funnels } from '@puls/puls-common-constants'
import AppStorage from './appstorage.js';
import { funnelUtilsConstants as utilsConstants } from '@puls/puls-common-constants';
import qs from 'qs'
import validators from './validations.js';
import handymanUtils from './handyman.js';
import ServicesCalculator from './calculators/services.js';
import { plans as plansCommonConstants } from '@puls/puls-common-constants'
import Initializer from '../../init.js';
import config from '../../config.js';
import init from '../../init.js';
import timeSlotsUtils from '../../time-slots.js';
import formatPhoneLink from './utils/formatPhoneLink';
const { STRATEGY_TYPES } = utilsConstants;

let VerificationFunnels = null;
let PaymentFunnels = null;
let ABTestConstants = null;
let ABTestUtils = null;
let routesConstants = null;
let funnelsCodes = null;
let namePrice = null;
let realEstateUtils = null;
let realEstateRoutes = null;
let IssueSelectConfig = null;
let realEstateConstants = null;
let priceUtils = null;
let pmWarrantyRoutes = null;

const valueTestsMap = {
    1: "A",
    2: "B",
    3: "C"
}


export default {
    init: () => {
        const obj = Initializer.params;
        VerificationFunnels = obj.VerificationFunnels;
        PaymentFunnels = obj.PaymentFunnels;
        routesConstants = obj.routesConstants;
        funnelsCodes = obj.funnelsCodes;
        namePrice = obj.namePrice;
        realEstateUtils = obj.realEstateUtils;
        realEstateRoutes = obj.realEstateRoutes;
        IssueSelectConfig = obj.IssueSelectConfig;
        realEstateConstants = obj.realEstateConstants;
        priceUtils = obj.priceUtils;
        pmWarrantyRoutes = obj.pmWarrantyRoutes
    },
    convertToServerJson,
    convertToServerJsonSale,
    getSessionId,
    getPostalCode,
    getCookieByName,
    getAxiosConfig,
    controlHistory,
    dispatchAppointmentCreationMessage,
    getPaymentErrorMessage,
    getTestGroupObject,
    getRandomFromRange,
    getRandomBool,
    canShaowAppointmentVerificationFlow,
    validateAppointment,
    getCoord,
    getFormattedGA,
    getQNumber,
    checkForTimeEstimationChange,
    isMarketNotAlinged,
    acuireFunnelCode,
    acuireFunnelId,
    acuireFunnelGUID,
    getCustomerDevicesIngridiants,
    getServicesCountFromAggregated,
    getTrustServiceFeeService,
    getAddressDataComponents,
    canShowPayment,
    getSelectedSale,
    isAppointmentHasDiagnostic,
    isPrefferedFlatRate,
    showFileUploadStep,
    isFileValid,
    getNoDeviceServicesCalcObj,
    isValidForUpsellAbTest,
    listenToPaymentNonceEvent,
    calculateProgressBarWidth,
    canShowSaleProgressBar,
    getProgressBarCurrentStep,
    canShowInvalidSaleEmail,
    sendSaleLeadToServer,
    isValidForHourlyPricesAbTest,
    getContactObject,
    isProtectionPlan,
    isYearlypaymentType,
    getDiscountSalePrice,
    isRealEstateFlow,
    getSaleFlow,
    generatePlansByFlow,
    calculateCustomerCredit,
    isCustomePriceLowerFromPlan,
    getInjectedServerData,
    getContactDataObject,
    isCheckupFlow,
    getErrorRedirectLink,
    isMileStoneValidSid,
    mobileCheck,
    canShowMarketsDisclamer,
    getPlanDefaultBenefit,
    getCartTotalText,
    getPageviewAdditionalPayload,
    getAddonsTotalPriceForDisplay,
    isValidForExpediteAbTest,
    canSelectAllAddons,
    getCustomBudgetAmountWithoutTax,
    generateAddonsWithCustomBudget,
    insertGoogleTagManagerScript,
    insertGoogleMapsScript,
    getFlowMap,
    getQueryString,
    getArraysDiff, 
    mapAddonsByCategory,
    determineArticle, 
    isHdmFlow,
    getSalePriceWithIssuerDiscount,
    isBAF,
    isContainsBafDevice,
    isContainsHisenseDevice,
    getPriceWithDiscount,
    getPriceWithCoupon,
    isHdmPayment,
    formatPhoneNumber,
    saveEntryContext,
    getEntryContext,
    getSelectedDeviceId, 
    getAppointmentState,
    isRealEstateDefaultFlow,
    generateABTestValuesArray,
    pickRandomValueFromArray,
    priceFormatter,
    isValidForAprImprovementTest,
    formatPhoneLink,
    isAuxSaleFlow,
    isPMWarrantyRoute, 
    isPMWarrantyFlow,
    isPMWarrantyPlan,
    isPMWarrantyService,
    isSuperFlow,
}


function sendSaleLeadToServer(appState, location){
    const { client_uuid } = appState.config;
    const contact = getContactObject(appState);
    if(!contact.email) return;
    const analytics = getAnalyticsObject(appState, {is_lead: true})
    const params = {
        first_name: contact.first_name,
        last_name: contact.last_name,
        email: contact.email,
        phone: contact.phone,
        address: contact.full_address,
        zipcode: contact.zip,
        market: contact.market_id,
        market_name: appState.zipcode.marketName,
        origin: getAppointmentOrigin(appState),
        ...analytics
    }

    try{
        params.user_agent = window.navigator.userAgent;
    } catch (e) {}

    try{
        params.plan_id = appState.sales.selected_sale_id || appState.sales.pre_selected_plan_id;
    } catch (e) {}

    try{
        params.uuid = client_uuid;
    } catch (e) {}

    try{
        params.last_url = location.pathname;
    } catch (e) {}

    Axios.post(config.api+ 'api/sales/lead', params).then(() => {}).catch(() => {})
}

function isFileValid(file){
    return (file.size <= 20*1000*1000 && !!file.name.match(/.(jpg|jpeg|png|gif)$/i))
}

const FUNNEL_IMAGE_UPLOAD = [18, 3];
function showFileUploadStep(appState){
    if(appState.config.creating_in_admin) return false;
    var funnelId = acuireFunnelId(appState.handyman);
    if(FUNNEL_IMAGE_UPLOAD.indexOf(funnelId) !== -1){
        try {
            // var abTestFileUpload = ABTestUtils.getTestValue(ABTestConstants.IMAGE_UPLOAD);
            // return abTestFileUpload === 'B'
            return true;
        } catch (error) {
            
        }
    }

    return false;
}

const FUNNEL_WITH_PREFFERED_FLAT_RATE = [15, 14];
function isPrefferedFlatRate(appState){
    var funnelId = acuireFunnelId(appState.handyman);
    return FUNNEL_WITH_PREFFERED_FLAT_RATE.indexOf(funnelId) !== -1;
}


function getMarketIdFromAppState(appState){
    try {
        return (appState.address.googleData && appState.address.googleData.googleMarketId) || appState.zipcode.marketId || null;
    } catch (e) {
        return null;
    }
}

function convertToServerJsonSale(appState){
    let analytics = getAnalyticsObject(appState);
    let serverObj = null
    const selectedSale = appState.sales.salesListMap[appState.sales.current_sale_type][appState.sales.selected_sale_id];
    const isYearlyType = isYearlypaymentType(appState.sales.payment_type);
    try {
        serverObj = {
            analytics,
            uuid: appState.config.client_uuid,
            contact: getContactObject(appState),
            type: appState.sales.current_sale_type,
            sale_id: appState.sales.selected_sale_id,
            services: [
                {
                    price: isYearlyType ? selectedSale.price : selectedSale.price_monthly,
                    id: isYearlyType ? selectedSale.service_id : selectedSale.service_id_monthly,
                    plan_id: selectedSale.plan_id,
                    title: selectedSale.title
                }
            ],
            entity_source_id: 1,
            price : calculateFunnelPrice(appState),
            tax: getTaxPrice(appState)
        }
        
        if(appState.config.flow === utilsConstants.FLOWS_IDS.REAL_ESTATE) {
            serverObj.contacts_auxiliary = realEstateUtils.getAuxiliaries(appState);
            serverObj.properties = JSON.stringify(realEstateUtils.getRealEstateSaleProperties(appState));
        }

        try {
            const discountPrice = getDiscountSalePrice(appState);
            if(discountPrice) {
                serverObj.services.push({ id: 1077, price: discountPrice, payment: discountPrice, plan_id: selectedSale.plan_id})
            }
        } catch (error) {
            
        }

        try {
            const customePrice = calculateCustomerCredit(appState);
            if(customePrice) {
                serverObj.services.push({ id: customePrice > 0 ? 1666 : 1077, price: Math.abs(customePrice), payment: Math.abs(customePrice), plan_id: selectedSale.plan_id})
            }
        } catch (error) {
            
        }

        if(isAuxSaleFlow(appState.config.flow)) {
            appState.sales.planAddons.forEach((addon) => {
                if(addon.selected) {
                    const selectedServiceDetails = appState.prices.pricesListMap[addon.withService];
                    serverObj.services.push({
                        id: isYearlyType ? addon.withService : addon.withServiceMonthly,
                        price: isYearlyType ? selectedServiceDetails.totalPrice : selectedServiceDetails.monthlyPrice,
                        title: selectedServiceDetails.serviceDisplayTitle
                    })
                }
            })

            try {
                (appState.handyman.autoAddedServices || []).filter(ser => ser.serviceId !== utilsConstants.SUBSCRIPTION_DISCOUNT_SERVICE_ID).forEach(ser => {
                    serverObj.services.push({
                        price: ser.totalPrice,
                        id: ser.serviceId,
                        plan_id: selectedSale.plan_id,
                        title: ser.serviceDisplayTitle
                    });
                })
            } catch (error) {
                
            }
        }
        
    } catch (e) {
        serverObj = null
        console.log(e)
    }
    console.log("###############################");
    console.log("AppState ==>\n", appState);
    console.log("###############################");
    console.log("Request Object ==>\n", serverObj);
    console.log("###############################");
    return serverObj;
}

function convertToServerJson(appState, opts = {}){
    const appointmentState = getAppointmentState(appState);
    let appointmentOrigin = getAppointmentOrigin(appState);
    let promoCode = (appState.coupon && appState.coupon.promoCodeValidationData.isValid) ?  appState.coupon.promoCode : '';
    let marketId = getMarketIdFromAppState(appState);
    let funnelId = acuireFunnelId(appointmentState);
    let analytics = getAnalyticsObject(appState);
    let isAssigned = appState.technician && appState.technician.isWantBeAssigend;
    if(appState.config.amp_props && appState.config.amp_props.amp_device_id){
        analytics = assign({}, analytics, appState.config.amp_props);
    } else {
        let _amp_props = {
            amp_device_id: getAmplitudeDeviceId(),
            amp_session_id: getAmplitudeSessionId(),
            amp_client_ip: ''
        };
        analytics = assign({}, analytics, _amp_props);
    }

    let ab_tests = appState.config.creating_in_admin ? [] : getUserABTestSelection();

    // ab_tests.push({
    //     name: "Thankyou Page Membership Upsell V2",
    //     value: valueTestsMap[Math.floor(Math.random() * 2) + 1]
    // });

    const {selectedUpsellMembershipId} = appointmentState;
    const selectedTimeSlot = timeSlotsUtils.getSingleSelectedTimeSlot(appState.time.timeSlotsMap);
    const selectedDate = selectedTimeSlot.date;
    let requestObj = {
        analytics,
        funnelId,
        appointment_funnel_code: acuireFunnelCode(appointmentState),
        appointment_id : "",
        discount: (appState.coupon && appState.coupon.promoCodeValidationData.discountInDollars) || null,
        date : parseInt(moment.utc(selectedDate, 'YYYY MM DD').format('x')),
        dateString: selectedDate,
        emailed : '',
        extra_data : '',
        id : '',
        is_redo : false,
        issue_description : '',
        latitude : getCoord('lat', appState),
        longitude : getCoord('lng', appState),
        contact: getContactObject(appState),
        customer_devices : getCustomerDevices(appState),
        customer_referred_by : '',
        market_id : marketId,
        offset : getTimeZoneOffset(),
        origin : appointmentOrigin,
        price : calculateFunnelPrice(appState),
        tax: getTaxPrice(appState),
        promo_code : promoCode,
        reg_date : '',
        scope : "new_job",
        start_time : selectedTimeSlot.start_time,
        status_id : 1,
        technician_id : isAssigned ? appState.technician.id : null,
        uuid : appState.config.client_uuid,
        ab_tests,
        fe_internal_data: {
            is_subscribed: appState.userdetails.isUserSubscribed,
            subscription_plan_id: appState.userdetails.plan.id || selectedUpsellMembershipId,
            subscription_account_id: appState.userdetails.subscription.account_id,
            is_appointment_prepaid: appState.payment && appState.payment.isApptPaid,
            funnel_entry_link: getCookieValueWithFallback("funnel_entry_link")
        },
		openZipcode: !!appState.zipcode.openZipcode,
        timeslots: timeSlotsUtils.getSelectedTimeSlots(appState.time.timeSlotsMap)
    };

    try {
        requestObj.media_urls = appState.mediafile.files.filter(f => f.fileLinkData && f.fileLinkData.filename).map(f => f.fileLinkData.filename);
    } catch (error) {
        
    }
    

    if(!requestObj.data) requestObj.data = {};
    if(appState.config.creating_in_admin){
        requestObj.data = {skip_ab_test: 1};
    } else {
        var groupMappingId = AppStorage.ServerContextObject.get(marketId, funnelId);
        if(groupMappingId){
            let idNumber = null;
            let isValid = false;
            try {
                idNumber = parseInt(groupMappingId)
                isValid = isFinite(idNumber);
            } catch (e) {
                    console.log(e)
            }
            if(isValid) requestObj.data = {[utilsConstants.SERVER_AB_TEST_GROUP_ID]: idNumber};
        }
    }

    if(appState.verification && appState.verification.isVerified && appState.verification.verificationMethod) {
        requestObj.data.verification_method = appState.verification.verificationMethod;
    }

    if(appState.userdetails.partner) requestObj.partner_id = appState.userdetails.partner.id;

    if(appState.config.referral_code && appState.userdetails.referral.is_valid) requestObj.referral_code = appState.config.referral_code;

    if(selectedUpsellMembershipId) requestObj.subscription_plan_id = selectedUpsellMembershipId;

    if(opts.captchaToken) requestObj.fe_internal_data.captchaToken = opts.captchaToken;

    console.log("###############################");
    console.log("AppState ==>\n",appState);
    console.log("###############################");
    console.log("Request Object ==>\n",requestObj);
    console.log("###############################");
    return requestObj
}

function getContactObject(appState){
    let addressData = getAddressDataComponents(cloneDeep(appState));
    const contactObj = {
        first_name: appState.userdetails.firstname,
        last_name:  appState.userdetails.lastname,
        street_number: addressData.street_number || '',
        full_address : appState.address.googleData && appState.address.googleData.formatted_address || '',
        apartment : appState.address.additional || '', //apartment field
        zip: addressData.postal_code || appState.zipcode.zipcode || (appState.address.googleData && appState.address.googleData.googleMarketId === 20 ? '888' : '') || '',
        city: (addressData.locality ||  addressData.sublocality || addressData.sublocality_level_1 )|| '',
        street: addressData.route || '',
        phone: appState.userdetails.phone,
        email: appState.userdetails.email,
        instructions : appState.address.optional || '',
        market_id: getMarketIdFromAppState(appState),
        state : addressData.administrative_area_level_1 || '',
        latitude : getCoord('lat', appState),
        longitude : getCoord('lng', appState)
    }

    const properties = getContactProperties(appState);
    if(Object.keys(properties).length) contactObj.properties = properties;

    if (isPMWarrantyFlow(appState.config.flow)) { 
        contactObj.account_id = appState.userdetails.auxiliaries[utilsConstants.USERS.PROPERTY_MANAGER].accountId;
    }

    return contactObj;
}

function getContactProperties(appState) {
    const properties = {};
    const { super_subscriber_id } = appState.config;
    if(super_subscriber_id) properties.super_subscriber_id = super_subscriber_id;
    return properties;
}

function stasTransform(txt){
    if(!txt) return '';
    var _text = decodeURIComponent(txt);
    if(_text.includes('j:')) _text = _text.replace(/^j:/g, ''); 
    return _text;
}

function getSource(appState) {
    if(appState.config.isClaimFlow) return 'claimCrossSale';
    return (appState.technician && appState.technician.id) ? "crossSell" : getCookieValueWithFallback('utm_source');
}

function getCookieValueWithFallback (name) {
    var sessionEntryParams = {};
    try {
        sessionEntryParams = window.sessionStorage.getItem('__entry_query_parameters__')
        if(sessionEntryParams) sessionEntryParams = JSON.parse(sessionEntryParams)
    } catch (error) {
        sessionEntryParams = {}
    }
    var value = getCookieByName(name) || (window.__entry_query_parameters__ && window.__entry_query_parameters__[name]) || (sessionEntryParams && sessionEntryParams[name]) || '';
    return stasTransform(value)
}


function getLandingPage() {
    try {
        if(window.location.pathname.indexOf(config.createOrderClientRoot) !== -1) return 'short-appointment-creation';
    } catch (error) {
        
    }
    
    return window.referrer
}

function getAnalyticsObject(appState, opts = {}){
    let appointmentOrigin = getAppointmentOrigin(appState);
    let ga4_session_id = '';

    try {
        ga4_session_id = getCookieByName('_ga_TBM8N6QSZE') || getCookieByName('_ga_PSF87ZC399') || '';
    } catch (error) {
        
    }

	let campaign = getCookieValueWithFallback('utm_campaign');
    let campaign_id = getCookieValueWithFallback('utm_campaign_id');

	try {
		if (campaign_id && campaign && typeof campaign === 'string' && campaign.indexOf(',') !== -1) {
			const tmp = campaign.split(',').filter(a => (a !== campaign_id));
			if (!!tmp.length) {
				campaign = tmp.join(',')
			}
		}	
	} catch (error) {
		
	}
	
    let obj = {
        campaign,
        campaign_id,
        content : getCookieValueWithFallback('utm_content'),
        click_id :  getCookieValueWithFallback('click_id') || getCookieValueWithFallback('gclid'),
        landing_page : getLandingPage(),
        medium : stasTransform(appState.config.from_appointment_id || getCookieValueWithFallback('utm_medium')),
        origin : appointmentOrigin,
        admin_username : appState.config.admin_username,
        source : stasTransform(getSource(appState)),
        term : getCookieValueWithFallback('utm_term'),
        ad_id : getCookieByName('ad_id'),
        ga: getCookieByName('_ga'),
        creator_id: (appState.technician && appState.technician.id) || appState.config.creator_id,
        browser_id: getCookieByName('_fbp') || ''
    };

    if(ga4_session_id) obj.ga4_session_id = ga4_session_id;

    if(appState.config.isUpdaterFlow){
        obj.source = 'affiliate';
        obj.campaign = 'updater';
    }

    if(appState.config.flow === utilsConstants.FLOWS_IDS.REAL_ESTATE) {
        obj.source = 'affiliate';
        obj.campaign = 'real-estate';
    }
    if(appState.config.flow === utilsConstants.FLOWS_IDS.BIZZ_DEV_SOUTHEAST) {
        obj.source = 'affiliate';
        obj.campaign = 'southeast-energy-consultants';
    }

    try {
        if(document.referrer.indexOf("book-a-service?networx_sales_flow=1") !== -1){
            obj.source = 'networx';
        }
        if(document.referrer.indexOf("book-a-service?bark_sales_flow=1") !== -1){
            obj.source = 'bark';
        }
        if(document.referrer.indexOf(config.consumerDomainBase) !== -1){
            obj.source = 'consumer_portal';
        }

        if(appState.config.flow === utilsConstants.FLOWS_IDS.DEFAULT && getCookieByName("membership_clicked_from_thankkyou")) {
            obj.landing_page = 'typ-pop-up';
        }

        try {
            const parentDomain = window.parent.location.hostname;
            if (parentDomain === 'insperationhub.com') {
                obj.source = 'insperation_hub';
            }
        } catch (error) {
            
        }
    } catch (error) {
        
    }
    

    if(opts.is_lead){
        ["source", "medium", "campaign", "content", "term"].forEach(key => {
            obj[`utm_${key}`] = obj[key];
            delete obj[key];
        });
    }

    return obj;
}

function getAppointmentOrigin(appState){
    let origin = Initializer.strategy.getAppointmentOrigin(appState);
    try {
        origin = decodeURIComponent(origin)
    } catch (e) {
        //
    }
    return origin;
}

function getTaxPrice(appState){
    const appointmentState = getAppointmentState(appState);
    return appointmentState.taxPrice || 0;
}

function getAddressDataComponents(appState){
    var addressData = {};
    if(!appState.address.googleData) appState.address.googleData = {address_components : []};
    if(appState.address.googleData && appState.address.googleData.address_components){
        appState.address.googleData.address_components.forEach((comp)=>{
            comp.types.forEach((type)=>{
                addressData[type] = type === "administrative_area_level_1" ? comp.short_name : comp.long_name
            })
        })
    }

    return addressData;
}

function getCustomerDevices(appState){
    const type = Initializer.type;
    const appointmentState = getAppointmentState(appState);
    let { selectedService, selectedServicesCart } = appointmentState;

    let all = [];

    if(selectedServicesCart && selectedServicesCart.length){
        selectedServicesCart.forEach((selectedService) => {
            all.push(createCustomerDevice(selectedService))
        })
    }

    if(selectedService){
        all.push(createCustomerDevice(selectedService))
    }

    function createCustomerDevice(selectedService){
        let services = ServicesCalculator(selectedService)
        let properties = init.strategy.getDeviceProperties(selectedService, appointmentState);
        
        if(isCheckupFlow(selectedService)){ // for home checkup
            properties = Object.assign({} , properties, HOME_CHECKUP_PROPERITES)
        }

        const pricesObj = type === STRATEGY_TYPES.BLENDER ? appointmentState.priceIngredientsMap : appState.prices.pricesListMap;

        return {
            color : {title : (properties && properties['Color']) || selectedService.deviceWithColor || "Any"},
            device : {id : selectedService.id, phone_family : selectedService.funnelConfig.serviceName, phone_model: selectedService.name },
            services : services.map((serviceId) => {
                var service = pricesObj[selectedService.id][serviceId];
                return {
                    id: service.serviceId,
                    is_upsell: service.isUpsell || false, // need to include upsells in the future
                    title: (service.serviceDisplayTitle || service.serviceName),
                    price: service.totalPrice,
                    payment: service.totalPrice
                }
            }),
            properties
        }
    }
    
    if(appState.handyman) {
        if([selectedService, ...selectedServicesCart].filter(a => a).some(service => isBAF(service.id))){
            const fansCount = all[0].services.length;
            const device = all.pop()
            device.services = [device.services[0]];
            for (let index = 0; index < fansCount; index++) {
                all.push(device);
            }
        }
    }

    if(appointmentState.autoAddedServices && all[0]){
        try{
            appointmentState.autoAddedServices.forEach((service) => {
                all[0].services.push({
                    id: service.serviceId,
                    is_upsell: service.isUpsell || false, // need to include upsells in the future
                    title: (service.serviceDisplayTitle || service.serviceName),
                    price: service.totalPrice,
                    payment: service.totalPrice
                })
            })
            
        } catch(e){
            console.error(e);
        }
    }

    if(all[0]){
        appState.userdetails.plan.benefits.filter(a => a.selected).forEach(benefit => {
            let priceObject = appointmentState.priceIngredients.find(p => p.serviceId === benefit.service_id);
            let price = (priceObject && Math.abs(priceObject.totalPrice)) || benefit.total_saving;
            all[0].services.push({
                id: benefit.service_id,
                is_upsell: false, // need to include upsells in the future
                title: benefit.title,
                price,
                payment: price
            })
        })
    }

    return all;
}

function getAmplitudeDeviceId(){
    let id = '';
    try {
        id = window.amplitude.getInstance().options.deviceId;
    } catch (e) {
        id = '';
    }
    return id;
}

function getAmplitudeSessionId(){
    let id = '';
    try {
        id = window.amplitude.getSessionId();
    } catch (e) {
        id = '';
    }
    return id;
}

function getDeviceProperties(selectedService){
    let all = {};
}

let getUserABTestSelection = () => {
    let prop = 'ab test';
    let all = {};
    try {
        window.dataLayer.forEach((item) => {
            if (Object.keys(item).indexOf(prop) !== -1) {
                let currItem = item[prop];
                if (Array.isArray(currItem)) {
                    currItem.forEach((abtest) => all[abtest.name] = abtest)
                } else {
                    all[currItem.name] = currItem;
                }
            }
        });
    } catch (e) {
        all = {};
    }

    return values(all).map(a => {
        a.value = a.variation;
        delete a.variation;
        return a;
    });
};

function calculateFunnelPrice(appState){
    const appointmentState = getAppointmentState(appState);
    return appointmentState.totalPrice;
}

function isCheckupFlow(selectedService) {
    return selectedService && isCheckupSid(selectedService.id);
}

function isMileStoneValidSid(sid) {
    return isCheckupSid(sid) || sid == utilsConstants.HVAC_SID;
}

function isCheckupSid(sid) {
    return sid == utilsConstants.CHECKUP_SID;
}

function getErrorRedirectLink (params) { 
    delete params['email'];
    delete params['sid'];
    const q = Object.keys(params).length ? `?${qs.stringify(params)}` : '';
    return `/create-appointment/select-issue${q}`;
}

function getTimeZoneOffset () {
    let offset = new Date().getTimezoneOffset();
    let o = Math.abs(offset);
    return (offset < 0 ? '+' : '-') + ('00' + Math.floor(o / 60)).slice(-1);
}

function getSessionId(){
    let _Cookies = null;
    let sessionId = '';
    try{
        _Cookies = document.cookie.split(';').map(a => a.trim());
        _Cookies.forEach(cook => {
            let parts = cook.split('=');
            let key = parts[0];
            let value = parts[1];
            if(key === "PHPSESSID") sessionId = value;
        })
    } catch(e) {
        console.log(e);
    }

    return sessionId;
}

function getPostalCode(address_components){
    let postal_code = '';
    if(!address_components) return postal_code;
    try{
        let postCodeIndex = -1;
        address_components.forEach( comp => {
            if(comp.types && comp.types[0] === 'postal_code'){
                postal_code = comp.short_name || comp.long_name
            }
        });
    } catch(e){
        console.log(e)
    }

    //try to check if test market -- israel address
    if(!postal_code){
        try{
            address_components.forEach( comp => {
                if(comp.types && comp.types.indexOf('country') !== -1){
                    if(comp.short_name.toLowerCase() === 'il' || comp.long_name.toLowerCase() === 'israel') postal_code = 888;
                }
            });
        }catch(e){
            console.log(e)
        }
    }

    return postal_code;
}

function getCookieByName(name){
    let _Cookies = null;
    let result = '';
    try{
        _Cookies = document.cookie.split(';').map(a => a.trim());
        _Cookies.forEach(cook => {
            let parts = cook.split('=');
            let key = parts[0];
            let value = parts[1];
            if(key === name) result = value;
        })
    } catch(e) {
        console.log(e);
    }

    return result;
}

function getAxiosConfig() {
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosConfig;
}

function controlHistory(url) {
    setTimeout(() => {
        window.location.href = url;
    }, 1500)
}

function dispatchAppointmentCreationMessage(message, title, dispatch){
    dispatch({
        type : actionConstants.TOGGLE_ERROR_MODAL,
        payload : {
            message,
            main_message : title
        }
    })
}

function getPaymentErrorMessage(response) {
    if(response.response && response.response.data && typeof response.response.data.message === 'string') return response.response.data.message;
    if(response.data && response.data.message && typeof response.data.message === 'string') return response.data.message;
    if(response.data && response.data.data && response.data.data.message && typeof response.data.data.message === 'string') return response.data.data.message;
    if(response.message && typeof response.message === 'string') return response.message;

    return 'Somthing went wrong';
}

function getTestGroupObject(data){
    let id = null;
    try {
        id = data.extraDetails.grouping;
    } catch (e) {
        id = null;
    }

    return id;
}

function getRandomFromRange(a, b){
    return Math.floor((Math.random() * b) + a);
}

function getRandomBool(opts = {}) {
    if(opts.getBVersion) return false;
    // true for A;
    var threshHold = opts.threshHold || 0.5
    return Math.random() >= threshHold;
}


function canShaowAppointmentVerificationFlow(){
    if(this.props.config.creating_in_admin) return false;
    let funnelId = acuireFunnelId(this.props.handyman);
    let marketId = (this.props.address.googleData && this.props.address.googleData.googleMarketId) || this.props.zipcode.marketId;
    // get the custome funnl market verification or thak the default
    var verificationObject = VerificationFunnels[funnelId] || VerificationFunnels[0];
    if(verificationObject.ALWAYS_VERIFY_MARKETS.indexOf(marketId) !== -1) return true;

    // disable the verification feature except charlotte market
    return false;
    var showVerificationABTestValue = getCookieByName('ab_test_appt_verification');
    if(!showVerificationABTestValue) return false;
    var isMarketInABTest = verificationObject.AB_TEST_VERIFICATION_MARKETS.indexOf(marketId) !== -1;
    if(isMarketInABTest){
        window.dataLayer && window.dataLayer.push({
            "ab test": {
                name: 'Appointment code verification',
                variation: showVerificationABTestValue
            }
        });
        return showVerificationABTestValue === 'B';
    } else {
        return false
    }
}

function isAppointmentHasDiagnostic(handymanReducer){
    let { selectedService, selectedServicesCart } = handymanReducer;

    var allSelectedServices = [selectedService]
    if(selectedServicesCart.length) allSelectedServices = allSelectedServices.concat(selectedServicesCart);
    var services = allSelectedServices.reduce((acc, next) => {
        return acc.concat(ServicesCalculator(next))
    }, []);

    return services.some((service) => service === utilsConstants.DIAGNOSTIC_SERVICE_ID);
}

function validateAppointment() {
    const strategy = init.strategy
    let isDevicesValid = [strategy.apptReducerName].reduce((a,b)=> {
        let isValid = validators.validateReducer(this.props[b] , b)
        return isValid || a
    } ,false);

    let isOtherFeildsValid = ['time', 'address', 'userdetails'].reduce((a,b)=>{
        let isValid = validators.validateReducer(this.props[b] ,b)
        return a && isValid
    }, true);

    // let { isValidZipcode } = this.props.zipcode;

    return isDevicesValid && isOtherFeildsValid;
}

function getCoord(coord, appState) {
    let value = '';
    try {
        value = appState.address.googleData && appState.address.googleData.geometry && appState.address.googleData.geometry.location[coord]()
    } catch (e) {
        value = appState.address.googleData && appState.address.googleData.geometry && appState.address.googleData.geometry.location[coord]
    }
    return value || 0;
}

function getFormattedGA() {
    let _ga = getCookieByName('_ga');
    let ga_cid = ''
    if(_ga) {
        try {
            let gaParts = _ga.split('.');
            ga_cid = gaParts[gaParts.length - 2] + '.' + gaParts[gaParts.length - 1];

        } catch (e) {
            console.log('cant parse _ga');
            ga_cid = ''
        }
    }

    return ga_cid;
}

function getQNumber(props) {
    let res = 0;
    try {
        // old way to much js opration
        // res = parseInt(this.props.location.pathname.split('/').reverse()[0].replace('q', ''));
        res = parseInt(props.location.pathname.match(/\q[0-9]{1,2}/)[0].substr(1));
    } catch (e) {
        res = 0;
    }
    return res;
}

function checkForTimeEstimationChange(){
    const appointmentState = getAppointmentState(this.props);
    let {timeSlotsLoadedForDuration} = this.props.time;
    let {selectedService} = appointmentState;
    if(!selectedService) return false;
    if(selectedService.isSingleServiceAppointment || selectedService.customFunnelServices) return false;
    let numberOfHours = selectedService && handymanUtils.calculateNumberOfHouers(selectedService.questions);
    return (timeSlotsLoadedForDuration && numberOfHours) && (timeSlotsLoadedForDuration !== numberOfHours);
}

function isMarketNotAlinged(){
    return this.props.address.googleData && this.props.address.googleData.isGoogleZipCodeValid && (this.props.zipcode.marketId !== this.props.address.googleData.googleMarketId)
}

function acuireFunnelCode(appointmentReducer){
    return (
        (appointmentReducer.selectedService && appointmentReducer.selectedService.funnelConfig.funnelCode)
        ||
        (appointmentReducer.selectedServicesCart && appointmentReducer.selectedServicesCart[0] && appointmentReducer.selectedServicesCart[0].funnelConfig.funnelCode)
    );
}

function acuireFunnelId(appointmentReducer){
    return (
        (appointmentReducer.selectedService && appointmentReducer.selectedService.funnelConfig.funnelId)
        ||
        (appointmentReducer.selectedServicesCart[0] && appointmentReducer.selectedServicesCart[0].funnelConfig.funnelId)
    );
}

function acuireFunnelGUID(appointmentReducer){
    return (
        (appointmentReducer.selectedService && appointmentReducer.selectedService.funnelConfig.service_guid)
        ||
        (appointmentReducer.selectedServicesCart[0] && appointmentReducer.selectedServicesCart[0].funnelConfig.service_guid)
    );
}

function getCustomerDevicesIngridiants(appointmentReducer) {
    var {selectedService, selectedServicesCart} = appointmentReducer;
    let ingrid = []
    if(selectedServicesCart && selectedServicesCart.length){
        selectedServicesCart.forEach((selectedService) => {
            var deviceId = selectedService.id;
            var services = ServicesCalculator(selectedService);
            if(!services.length) return;
            ingrid.push({
                deviceId,
                services: services.map(serviceId => {
                    return {
                        serviceId
                    }
                })
            })
        })
    }

    if(selectedService){
        var deviceId = selectedService.id;
        var services = ServicesCalculator(selectedService);
        if(!services.length) return;
        ingrid.push({
            deviceId,
            services: services.map(serviceId => {
                return {
                    serviceId
                }
            })
        })
    }

    return ingrid;
}

function getServicesCountFromAggregated(aggregatedServicesForDisplay){
    return aggregatedServicesForDisplay.reduce((acc, device) => {
        return acc + ((device.services && keys(device.services).length) || 0);
    }, 0);
}

function getTrustServiceFeeService(appState){
    var deviceId = '';
    let { selectedService, selectedServicesCart } = appState.handyman;
    let service = null;
    try {
        if(selectedService) {
            deviceId = selectedService.id;
        } else if(selectedServicesCart.length) {
            deviceId = selectedServicesCart[0].id;
        }

        if(appState.prices.pricesListMap[deviceId]){
            service = appState.prices.pricesListMap[deviceId][utilsConstants.TRUST_AND_SERVICE_SERVICE_ID]
        }
    } catch (e) {
        console.error(e);
        service = null;
    }

    return service || null;
}

const paymentVerticals = [4, 15]
function canShowPayment(appState){
    var verticalId = acuireFunnelId(appState.handyman);
	const source = getCookieByName('utm_source');
    if(source === 'lnf') return true;
    if(paymentVerticals.indexOf(verticalId) !== -1 && source === 'facebook_payment') return true;
    return false;
    try {
        // admin flow or cross sale
        if(appState.config.creating_in_admin || appState.config.technician_id) return false;
        var verticalId = acuireFunnelId(appState.handyman);
        var marketId = getMarketIdFromAppState(appState);
        if(!verticalId || !marketId) return null;
        if(PaymentFunnels[verticalId]){
            var paymentVertical = PaymentFunnels[verticalId]
            if((typeof paymentVertical === 'string' && paymentVertical === 'all_markets') || PaymentFunnels[verticalId].indexOf(marketId) !== -1){
                var result = ABTestUtils.getTestValue(ABTestConstants.PAYMENT, {threshHold: 0.1});
                return result === 'B'
            }
        }

        return false;
    } catch (e) {
        console.error(e);
        return false;
    }
}

function getSelectedSale(salesReducer){
    let { current_sale_type, selected_sale_id } = salesReducer
    try{
        return salesReducer.salesListMap[current_sale_type][selected_sale_id];
    } catch(e){
        return null;
    }
}

function getAddonsTotalPriceForDisplay(salesReducer, pricesReducer, buyerCredit = 0) {
    if(!Object.keys(salesReducer.salesListMap).length || !salesReducer.selected_sale_id) return 0;
    const { payment_type } = salesReducer;
    const isYearlyPlan = isYearlypaymentType(payment_type);
    const selectedSalePlan = salesReducer.salesListMap[salesReducer.current_sale_type][salesReducer.selected_sale_id];
    const basePlanPrice = isYearlyPlan ? selectedSalePlan.price : selectedSalePlan.price_monthly;
    const selectedAddonsPrice = salesReducer.planAddons.filter((addon) => addon.selected).reduce((acc, selectedAddon) => {
        const priceMapService = pricesReducer.pricesListMap[selectedAddon.withService];
        acc += isYearlyPlan ? priceMapService.totalPrice : priceMapService.monthlyPrice;
        return acc;
    }, 0);
    return (basePlanPrice + selectedAddonsPrice + parseFloat(buyerCredit));
}

function getNoDeviceServicesCalcObj(servicesIds) {
    return {
        deviceId: 0,
        services: servicesIds.map((service) => {
            return {
                serviceId: service
            }
        })
    };
}

const partnerMapping ={
    [utilsConstants.BIG_ASS_FAN_DEVICE_ID]: 1
}

function isValidForUpsellAbTest(isSubscribed, appState) {
    const isInPartnerMapping = partnerMapping[appState.config.partner_context]
    const isUserSuperSubscriber = !!appState.config.super_subscriber_id;
    const funnelId = acuireFunnelId(appState.handyman);
    const validFlows = [utilsConstants.FUNNEL_IDS.TV];
    const isValidFlow = validFlows.some((id) => id === funnelId);
    return isValidFlow && !isSubscribed && !appState.technician.id && !isInPartnerMapping && !isUserSuperSubscriber;
}

function listenToPaymentNonceEvent(messsageEvent, onSuccess, client_uuid){
    const { data } = messsageEvent;
    let parsedData = null;
    try {
        parsedData = JSON.parse(data);
    } catch (error) {
        // console.error(error)
    }

    if(
        parsedData 
        && parsedData.message === 'authorized_prepayment_complete'
        && parsedData.payload.uuid === client_uuid
    ){
        onSuccess(parsedData.payload.nonce)
    }
}

function calculateProgressBarWidth(progressBarSteps, pathname) {
    let barWidth = 0;
    const indexOfPath = progressBarSteps.findIndex((plan) => plan.paths.includes(pathname));
    const amountOfFill = 100/(progressBarSteps.length - 1);
    const currentPaths = progressBarSteps[indexOfPath].paths;

    barWidth += amountOfFill * indexOfPath;

    if(currentPaths.length > 1) {
        const activeIndex = currentPaths.findIndex((path) => path === pathname);
        const subStepsFillAmount = (amountOfFill/currentPaths.length) * activeIndex;
        barWidth += subStepsFillAmount; 
    }
    return barWidth;
}

function canShowSaleProgressBar(pathname) {
    return [
        routesConstants.CS_APPLIANCES_SELECTION,
        routesConstants.CS_MEMBERSHIP,
        routesConstants.CS_SELECT_ADDRESS,
        routesConstants.CS_ENTER_USER_DETAILS,
    ].indexOf(pathname) !== -1
}

function getProgressBarCurrentStep(steps, pathname) {
    return steps.findIndex((step) => step.paths.includes(pathname)) + 1;
    
}

function canShowInvalidSaleEmail(isSale, userdetailsState, pathname) {
    if(!isSale) return false;
    const { isValid, isUserSubscribed } = userdetailsState;

    const hideError = [
        routesConstants.CS_ZIP_CODE,
        routesConstants.CS_ENTER_USER_DETAILS,
        routesConstants.RE_PROPERTY_ADDRESS,
        routesConstants.RE_AGENT_DETAILS,
        routesConstants.RE_BUYER_DETAILS,
        routesConstants.RE_WARRANTY_TRANSACTION_QUESTION,
        routesConstants.PM_COVERAGE_TYPE,
        routesConstants.PM_WARRANTY_MULTIPLE_PROPERTIES,
        routesConstants.PM_WARRANTY_PROPERTY_ADDRESS,
        routesConstants.PM_DETAILS,
        routesConstants.PM_HOME_OWNER_DETAILS,
    ].indexOf(pathname) !== -1;
    
    return (!isValid || isUserSubscribed) && !hideError;
}

function isValidForHourlyPricesAbTest(technicianReducer, handymanReducer) {
    return false;
    if(getCookieByName("utm_source") === 'ownerly') return false;
    // if there is a big ass fans device so we will always have 
    try {
        if([handymanReducer.selectedService, ...handymanReducer.selectedServicesCart].some(service => (service && service.id === utilsConstants.BIG_ASS_FAN_DEVICE_ID))) return false;
    } catch (error) {
        
    }

    if(
        technicianReducer.id ||
        acuireFunnelId(handymanReducer) !== funnelsCodes.HANDYMAN.funnelId
    ) return false;
    return true;
}

function isProtectionPlan(planId) {
    return utilsConstants.PLANS.PROTECTION_PLANS.includes(planId);
}

function isYearlypaymentType(paymentType) {
    return paymentType === 'y';
}

function getDiscountSalePrice(appState, plan_id){
    try {
        // this code is to give the realestate agents a way to create free sales with a discount
        if(appState.config.issuer === utilsConstants.REAL_ESTATE_ISSUER && (isRealEstateFlow(window.location.pathname) || appState.config.flow === utilsConstants.FLOWS_IDS.REAL_ESTATE)){
            const realEstateAvailablePlans = utilsConstants.MEMBERSHIP_PLANS_BY_FLOW.REAL_ESTATE.reduce((acc, next) => {acc[next] = 1; return acc;}, {});
            const availablePrices = appState.sales.salesList.filter(p => realEstateAvailablePlans[p.plan_id]).map(p => p.price);
            return Math.min(...availablePrices) - 0.01
        }

        const multiplyer = isYearlypaymentType(appState.sales.payment_type) ? 12 : 1;
        let discount = 0;
        const issuerPrice = namePrice[appState.config.issuer];
        if(typeof issuerPrice === 'object'){
            discount = issuerPrice[plan_id || appState.sales.selected_sale_id] || 0
        } else {
            discount = issuerPrice || 0
        }
        return discount * multiplyer;
    } catch (error) {
        return 0;
    }
}


function getSalePriceWithIssuerDiscount(appState, plan) {
    try {
        const discount = getDiscountSalePrice(appState, plan.plan_id)
        const totalPrice = isYearlypaymentType(appState.sales.payment_type) ? plan.price : plan.price_monthly;
        return discount > 0 ? (totalPrice - discount).toFixed(2) : null;
    } catch(e) {
        return;
    }
}

function isItemInMap(item, itemsMap) { 
    return Object.keys(itemsMap).some((a) => itemsMap[a] === item);
}

function isPMWarrantyRoute(path) { 
    return isItemInMap(path, pmWarrantyRoutes);
}

function isRealEstateFlow(path) {
    return isItemInMap(path, realEstateRoutes);
}

function getSaleFlow(payload) {
    if(isRealEstateFlow(payload.pathname)) {
        payload.store.dispatch({
            type: actionConstants.UPDATE_SALE_PAYMENT_TYPE,
            payload: utilsConstants.PAYMENT_TYPES.YEARLY
        })
        return utilsConstants.FLOWS_IDS.REAL_ESTATE;
    }
    if (isPMWarrantyRoute(payload.pathname)) return utilsConstants.FLOWS_IDS.PM_WARRANTY;
    if(parseInt(payload.params.flow) === utilsConstants.FLOWS_IDS.BIZZ_DEV_SOUTHEAST) return utilsConstants.FLOWS_IDS.BIZZ_DEV_SOUTHEAST;
    return utilsConstants.FLOWS_IDS.DEFAULT;
}

function isAuxSaleFlow (flow) { 
    return flow === utilsConstants.FLOWS_IDS.REAL_ESTATE || isPMWarrantyFlow(flow);
}

function isPMWarrantyFlow (flowId) { 
    return flowId === utilsConstants.FLOWS_IDS.PM_WARRANTY;
}

function generatePlansByFlow(flowId) {
    switch (flowId) {
        case utilsConstants.FLOWS_IDS.PM_WARRANTY:
            return plansCommonConstants.PLANS.PM_WARRANTY;
        case utilsConstants.FLOWS_IDS.REAL_ESTATE:
            return plansCommonConstants.PLANS.REAL_ESTATE;
        case utilsConstants.FLOWS_IDS.BIZZ_DEV_SOUTHEAST:
            return plansCommonConstants.PLANS.BIZZ_DEV_SOUTHEAST;
        default:
            return plansCommonConstants.PLANS.DEFAULT;
    }
}

function getCustomBudgetAmountWithoutTax(salesState) {
    const { custom_amount,  tax_details } = salesState;
    const tax_precentage = tax_details.taxPolicy === 2 ? tax_details.tax / 100 : 0;
    return parseInt(custom_amount) / (1 + tax_precentage)
}

function calculateCustomerCredit(appState, id = 0) {
    if(!isYearlypaymentType(appState.sales.payment_type)) return;
    try {
        const {current_sale_type, salesListMap, selected_sale_id, custom_amount, planAddons } = appState.sales;
        const { pricesListMap } = appState.prices;
        if(!custom_amount || !selected_sale_id) return 0;
        const sale = salesListMap[current_sale_type][id || selected_sale_id]
        const planPrice = sale.price;
        const totalSelectedAddonsPrice = planAddons.reduce((acc, addon) => {
            const addonPrice = addon.selected ? pricesListMap[addon.withService].totalPrice : 0;
            return acc + addonPrice;
        }, 0)
        return (getCustomBudgetAmountWithoutTax(appState.sales) - planPrice - totalSelectedAddonsPrice).toFixed(2);
    } catch (error) {
        console.log(error)
    }    
}

function canSelectAllAddons(sales, prices) {
    return true;
}

function generateAddonsWithCustomBudget(sales, prices) {
    if(!sales.custom_amount) return sales.planAddons;
    const newAddons = cloneDeep(sales.planAddons);
    return newAddons.map((addon) => {
        const addonPrice = prices.pricesListMap[addon.withService].totalPrice;
        const totalWithAdditionalAddon = getAddonsTotalPriceForDisplay(sales, prices) + addonPrice;
        addon.disabled = !addon.selected && (totalWithAdditionalAddon > getCustomBudgetAmountWithoutTax(sales));
        return addon;
    })
}

function isCustomePriceLowerFromPlan(plan, price){
    try {
        return price < plan.price
    } catch (error) {
        return false;
    }
}

const HOME_CHECKUP_PROPERITES = {
    "Tasks to complete": [
      "Home Appliance Check Up",
      "Check smoke/carbon monoxide detectors (replace batteries)",
      "Clean refrigerator coils",
      "Check ceiling fans (tighten/direction)",
      "Check toilets/sinks for leaks",
      "Check tile grout condition",
      "Replace light bulbs (if necessary)"
    ],
    "Materials Needed": [
      "Ladder",
      "Double A batteries",
      "Screwdriver",
      "Wrench",
      "Light bulbs",
      "Refrigerator Coils"
    ]
  }

function getInjectedServerData(elementId) {
    let data;
    if (process.env.NODE_ENV === 'production') {
        try {
            data = JSON.parse(document.getElementById(elementId).innerText);
        } catch(err) {}
    } else {
        //Mock data
        data = {
            first_name: 'Netanel',
            last_name: 'Haim'
        }
    }
    return data;
}

function getContactDataObject() {
    if(process.env.NODE_ENV !== 'development') {
        try {
            return JSON.parse(document.getElementById('server-contact-data').innerText);
        } catch (error) {
            return null    
        }
    }
    return {
        "data": {
            "subscription": {
                "id": 42505,
                "status": "Active",
                "contractUrl": "Puls Puls Whole Home netanel_42505.pdf",
                "uuid": "rl5nk3u0hyk2",
                "zipcode": "888",
                "account_email": "netanel.haim-pour@puls.com",
                "account_id": 710741,
                "first_name": "netanel",
                "last_name": "haim pour",
                "phone": "0543139590",
                "full_address": "Tel Aviv-Yafo, Israel",
                "start_date": "2022-08-03",
                "end_date": "2023-11-01",
                "plan_id": 10,
                "plan_title": "Puls Whole Home",
                "plan_type_id": 2,
                "payment_subscription_id": 829585,
                "entity_source_id": 2,
                "is_active": true,
                "price": 59.99,
                "is_auto_renew": true,
                "status_id": 1,
                "period_type": "m",
                "market_id": 20
            }
        },
        "is_succeeded": true
    }
}

function mobileCheck() {
	let check = false;
	(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);
	return check;
};

function canShowMarketsDisclamer(marketId) {
    const withDisclamer = [144, 145].includes(marketId);
    return withDisclamer ? 'Your service area is outside of our Click and Fix Network. Puls Warranty Customers in this area will not have access to On Demand Handyman services.': null;
}

function getPlanDefaultBenefit(benefits) {
    const defaultBenefit = benefits.filter((benefit) => benefit.value_type === utilsConstants.PRICE_VALUE_TYPE.PERCENTAGES).find((benefit) => benefit.is_default);
    return defaultBenefit ? defaultBenefit : { value: '15' }
}

const ServiceCallFeeFunnels = [14, 15, 17];
function getCartTotalText (handyman){
    const fid = acuireFunnelId(handyman)
    if(ServiceCallFeeFunnels.indexOf(fid) !== -1) return "Service Call Fee";
    return "Estimated";
}


function getPageviewAdditionalPayload(appointment){
    var obj = {};
    try {
        if(appointment.selectedServicesCart && appointment.selectedServicesCart.length){
            var dev = appointment.selectedServicesCart[0]
            obj.device_id = dev.id
            obj.device_name = dev.name
        }
    
        if(!obj.device_id && appointment.selectedService){
            obj.device_id = appointment.selectedService.id
            obj.device_name = appointment.selectedService.name
        }
    } catch (error) {
        
    }
    
    return obj;
}

function isValidForExpediteAbTest(handymanReducer, configReducer) {
    return false;
    //App flow validation
    const invalidAppFlows = [utilsConstants.FLOWS_IDS.NEW_CREATE_APPOINTMENT];
    const currentAppFlow = configReducer.flow;
    const isAppFlowValid = !invalidAppFlows.includes(currentAppFlow);
    if(!isAppFlowValid) return false;

    //Funnel validation
    const funnelId = acuireFunnelId(handymanReducer);
    const validFunnels = [utilsConstants.FUNNEL_IDS.HOME_APPLIANCES];
    const isValidFunnel = validFunnels.includes(funnelId);
    if(!isValidFunnel) return false;

    const validTestValue = ABTestUtils.getTestValue(ABTestConstants.EXPEDITE_TIME, {threshHold: 0.5}) === 'B';
    return validTestValue;
}

function insertGoogleTagManagerScript(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
    var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
}

function insertGoogleMapsScript(d, s) {
    const sc = d.createElement(s);
    sc.src= "https://maps.googleapis.com/maps/api/js?key="+config.googleMapsKey+"&libraries=places&language=en";
    let f = d.getElementsByTagName(s)[0];
    f.parentNode.insertBefore(sc, f);
}

function getFlowMap() {
    const flowMap = {};
    IssueSelectConfig.forEach(item => {
        if(!flowMap[item.path]) flowMap[item.path] = item.flow;
    });
    return flowMap;
}

function getQueryString() {
    return qs.parse(window.location.search, { ignoreQueryPrefix: true });
}

function getArraysDiff(source, dest, field) {
    let diffs = differenceBy(source, dest, field);
    if(!diffs.length) diffs = differenceBy(dest, source, field);
    return diffs;
}

function mapAddonsByCategory(addons){ 
    const obj = {}
    addons.forEach((addon, idx) => {
        const bundleId = addon.bundle.id;
        if(!obj[bundleId]) {
            obj[bundleId] = {
                title: addon.bundle.title, 
                addonsIdx: [],
                ...realEstateConstants.addonsCategories[bundleId]
            }
        }
        obj[bundleId].addonsIdx.push(idx)
    })
    return obj;
}

function isHdmFlow(appointmentReducer) {
    return acuireFunnelId(appointmentReducer) === funnelsCodes.HANDYMAN.funnelId
}

function determineArticle(name) {
    const vowels = ['a', 'e', 'i', 'o', 'u'];
    const firstLetter = name[0].toLowerCase();

    if (vowels.includes(firstLetter)) {
        return 'an';
    } else {
        return 'a';
    }
}

function isBAF(sid) {
    return isContainsBafDevice([sid]);
}

function isContainsBafDevice(devicesIds = []) {
    return devicesIds.some((deviceId) => deviceId === utilsConstants.BIG_ASS_FAN_DEVICE_ID);
}

function isContainsHisenseDevice(devicesIds = []) {
    const hisenseDevicesMap = utilsConstants.HISENSE_DEVICES_IDS.reduce((acc, devId) => {
        acc[devId] = true;
        return acc;
    }, {})
    return devicesIds.some((deviceId) => hisenseDevicesMap[deviceId])
}

function getPriceWithCoupon(appState, promocode) {
    let calculateParams = priceUtils.getPricesRequestObject(appState);

    if(calculateParams && calculateParams.ingredients && calculateParams.ingredients[0])
        calculateParams.ingredients[0].promocodes = [promocode];

    return Axios.post(config.api + 'api/price/calculate', calculateParams);
}

function getPriceWithDiscount(appState, discountPercent) {
    const calculateParams = priceUtils.getPricesRequestObject(appState);
    const totalPrice = appState.handyman.totalPrice;
    const discount = -1 * (totalPrice * (discountPercent / 100));

    if(!calculateParams) return;
        const discountService = {
            deviceId: 0,
            services: [{
                serviceId: 12,
                payment: discount
            }]
        }

    calculateParams.ingredients.push(discountService);

    return Axios.post(config.api + 'api/price/calculate', calculateParams);
}

function isHdmPayment(appState) {
    return false;
    try {
        if(!appState.userdetails.isUserSubscribed && !appState.coupon.promoCode) {
            return ABTestUtils.getTestValue(ABTestConstants.HANDYMAN_PAYMENT) === 'B';
        } 
    } catch(e) {}
}

function formatPhoneNumber(phoneNumber) {
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    if (digitsOnly.length === 10) {
        const areaCode = digitsOnly.substring(0, 3);
        const firstPart = digitsOnly.substring(3, 6);
        const secondPart = digitsOnly.substring(6);
        return `(${areaCode}) ${firstPart}-${secondPart}`;
    } else {
        return null; 
    }
}

function saveEntryContext(w){
    try {
        const context = {};
        if(w.p_email) {
            context.email = w.p_email;
            if(w.p_first_name) context.first_name = w.p_first_name;
            if(w.p_last_name) context.last_name = w.p_last_name;
            if(w.p_phone) context.phone = w.p_phone;
            if(w.p_building_address) context.building_address = w.p_building_address;
            if(w.p_building_name) context.building_name = w.p_building_name;
            if(w.p_unit_number) context.unit_number = w.p_unit_number;

            window.sessionStorage.setItem("entry_context", JSON.stringify(context))
        }
    } catch (error) {
        
    }
}

function getEntryContext(){
    try {
        const context = window.sessionStorage.getItem("entry_context")
        if(context) return JSON.parse(context)
    } catch (error) {
        
    }

    return {};
}

function isRealEstateDefaultFlow(flow) {
    return flow === realEstateConstants.FLOWS.DEFAULT;
}

function getSelectedDeviceId(appointmentReducer) {
    const { selectedService, selectedServicesCart } = appointmentReducer;
    return (selectedService && selectedService.id) || (selectedServicesCart && selectedServicesCart[0] && selectedServicesCart[0].id);
}

function getAppointmentState(appState) { 
    return Initializer.strategy.getAppointmentState(appState);
}

function generateABTestValuesArray({numOfValues = 2, weights}) {
    const variations = [];
    for (let i = 0; i < numOfValues; i++) {
        variations.push(String.fromCharCode(65 + i));
    }

    if(!weights) return variations;

    const totalWeights = weights.reduce((sum, weight) => {
        return sum += weight;
    }, 0)

    if(totalWeights !== 100) {
        throw new Error('total sum weights must be 100')
    }

    const duplicatesArray = [];

    for (let i = 0; i < numOfValues; i++) {
        const value = variations[i];
        const weight = weights[i];
    
        for (let j = 0; j < weight; j++) {
            duplicatesArray.push(value);
        }
    }

    return duplicatesArray;
}

function pickRandomValueFromArray(array) {
    return array[Math.floor(Math.random() * array.length)];
}

function priceFormatter(price) {
    return price < 0 ? `-$${Math.abs(price)}` : `$${price}`
}

function isValidForAprImprovementTest({handyman, config}) {
    const isAprFlow = acuireFunnelId(handyman) === funnelCodes.APPLIANCES_REPAIR.funnelId;
    const isAdmin = config.creating_in_admin;
    return !isAdmin && isAprFlow;
}

function isPMWarrantyPlan (planId) { 
    return utilsConstants.PLANS.PM_WARRANTY_PLANS.includes(planId)
}

function isPMWarrantyService(serviceId) { 
    return Object.values(funnelUtilsConstants.PM_WARRANTY_SERVICES).includes(serviceId)
}

function isSuperFlow(flow) {
    return flow === funnelUtilsConstants.FLOWS_IDS.SUPER;
}
